module.exports = __webpack_public_path__ + "static/media/fmg-logo.2b4a3e69.svg";